import mori from 'mori';
import { getCurrentDistributions } from '../util/dataFilters';
import getSelectedDistributions from './getSelectedDistributions';
import getSelectedColumns from './getSelectedColumns';
import getColumnKeys from './getColumnKeys';

/**
 * Generates selection keys and filters which are used by rendering functions
 *
 * @param {object} data The data store
 * @param {object} options Options from the url
 *
 * @return {array}
 */
export default function(data, options) {
  const isLocked = mori.getIn(data.config, ['globalRules', 'Locked'], false);

  const shouldGetDistributions = options.selectedDistributions &&
    (!isLocked || options.activeTab);

  // Get the current data view object by index
  const dataviewType = (data.globalSettings || {}).hasDataviews && !isLocked ?
    mori.nth(data.immutableDataviews, +(options.dataView || 0)) :
    false;

  // Get currently selected distributions, or all
  const distributions = shouldGetDistributions ?
    getCurrentDistributions(
      data.immutableDistributions,
      options
    ) :
    data.immutableDistributions;

  // Create sets as keys for data
  const selected = getSelectedDistributions(
    data,
    distributions,
    dataviewType
  );

  const columnKeys = getColumnKeys(data);

  // Join the base column and the selected sets
  const selectedSetKeys = mori.concat(mori.vector(columnKeys[0]), selected);

  // due to nesting we need to fix select all boxes...
  if (options.selectedRows) {
    options.selectedRows = assembleAllRows(data.columns, options.selectedRows);
  }
  // Return an array of arguments so we can apply it to other rendering
  // functions by using ...spread
  return [
    getSelectedColumns(data, options, ...columnKeys),
    selectedSetKeys,
    distributions,
    dataviewType,
    columnKeys,
  ];
}

// this rewrites nested select alls
function assembleAllRows(columns, rows) {
  const newTree = {};
  Object.keys(rows).forEach((curr) => {
    if (rows[curr].hasOwnProperty('all')) {
      const children = (columns.nested && curr !== 'nested') ?
        columns.nested[curr].children :
        columns[curr].children;
      if (typeof children === 'undefined' ||
        !children[Object.keys(children)[0]].hasOwnProperty('children')
      ) {
        newTree[curr] = rows[curr];
      } else {
        newTree[curr] = Object.keys(children).reduce((acc, item) => {
          acc[item] = { all: {} };
          return acc;
        }, {});
      }
    } else {
      newTree[curr] = rows[curr];
    }
  });
  return newTree;
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/getCombinedFilters.js